import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { Notice, Pager } from "../../lib/ui";
import { printHtml } from "../../lib/format";
import { grnHtml } from "../../lib/hrDocs";

/* GRN register – port of grn_list.php + grn_listAjax.php (API: /api/grns/register). Last 30 days by default, 8 per page.
   "Print" makes an A4 GRN (save as PDF from the print dialog). */

const COLS = [["grn_id", "GRN #"], ["po_id", "PO #"], ["received_date", "Received"], ["received_by", "Received by"], ["status", "Status"]];

export default function GrnRegister() {
  const api = useApi();
  const [q, setQ] = useState({ page: 1, sort: "grn_id", order: "DESC", search: "", start_date: "", end_date: "" });
  const [form, setForm] = useState({ start_date: "", end_date: "" });
  const [term, setTerm] = useState("");
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(async (p) => { try { const r = await api.get("/api/grns/register", p); setD(r); setForm({ start_date: r.start_date, end_date: r.end_date }); } catch (e) { setError(e.message); } }, [api]);
  useEffect(() => { load(q); }, [load, q]);
  useEffect(() => { const t = setTimeout(() => setQ((s) => (s.search === term ? s : { ...s, search: term, page: 1 })), 300); return () => clearTimeout(t); }, [term]);
  const sortBy = (k) => setQ((s) => ({ ...s, sort: k, order: s.sort === k && s.order === "ASC" ? "DESC" : "ASC", page: 1 }));
  return (
    <main className="pg">
      <PageHeader slug="grn_list" actions={<Link to="/grn" className="btn primary"><i className="fas fa-plus" /> New GRN</Link>} />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel">
        <form className="toolbar" onSubmit={(e) => { e.preventDefault(); setQ({ ...q, ...form, page: 1 }); }}>
          <div className="field grow"><label htmlFor="gr-q">Search</label><input id="gr-q" value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Status, received by or notes" /></div>
          <div className="field"><label htmlFor="gr-f">From</label><input id="gr-f" type="date" value={form.start_date} onChange={(e) => setForm({ ...form, start_date: e.target.value })} /></div>
          <div className="field"><label htmlFor="gr-t">To</label><input id="gr-t" type="date" value={form.end_date} onChange={(e) => setForm({ ...form, end_date: e.target.value })} /></div>
          <button type="submit" className="btn primary">Filter</button>
          <button type="button" className="btn" onClick={() => setQ({ ...q, start_date: "", end_date: "", page: 1 })}>Reset</button>
        </form>
        <div className="tbl-wrap"><table className="tbl">
          <thead><tr>{COLS.map(([k, l]) => <th key={k} className="sortable" onClick={() => sortBy(k)}>{l} {q.sort === k && <i className={`fas ${q.order === "ASC" ? "fa-sort-up" : "fa-sort-down"}`} />}</th>)}<th>Notes</th><th /></tr></thead>
          <tbody>{d?.rows.map((r) => <tr key={r.grn_id}><td className="mono">#{r.grn_id}</td><td className="mono">#{r.po_id}</td><td>{String(r.received_date).slice(0, 16)}</td>
            <td>{r.received_by || "–"}</td><td><span className="pill-tag">{r.status || "–"}</span></td><td style={{ color: "var(--muted)" }}>{r.notes || "–"}</td>
            <td><button type="button" className="btn sm" onClick={async () => { try { printHtml(grnHtml(await api.get(`/api/grns/${r.grn_id}/print`))); } catch (e) { setError(e.message); } }}>
              <i className="fas fa-print" /> Print</button></td></tr>)}</tbody>
        </table>{d && d.rows.length === 0 && <div className="empty"><i className="fas fa-truck-ramp-box" />No GRNs found.</div>}</div>
        {d && <Pager page={d.page} totalPages={d.pages} onPage={(p) => setQ({ ...q, page: p })} />}
      </section>
    </main>
  );
}
